// extracted by mini-css-extract-plugin
export var body = "_k3-0";
export var sectionHeader = "_k3-4";
export var shortcutColumns = "_k3-2";
export var shortcutList = "_k3-1";
export var shortcutSection = "_k3-3";